import AuthBackground from '@/components/Auth/AuthBackground.jpg';
import { cn } from '@/utils/tailwind';

export const VideoBackgroundPageWrapper = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'relative flex min-h-screen flex-col bg-background/20 bg-cover bg-center bg-no-repeat motion-reduce:visible',
        className
      )}
      style={{ backgroundImage: `url(${AuthBackground})` }}
    >
      <div className="absolute inset-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="h-full w-full object-cover motion-reduce:hidden"
        >
          <source
            src="https://customer-xp1a3vy0ydc4ega7.cloudflarestream.com/bb6cf069546e3d829aa5808ac8b07748/downloads/default.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="relative z-10 grid w-full flex-grow">{children}</div>
    </div>
  );
};
